import { render, staticRenderFns } from "./select-user.vue?vue&type=template&id=4522ed9b&scoped=true&"
import script from "./select-user.vue?vue&type=script&lang=js&"
export * from "./select-user.vue?vue&type=script&lang=js&"
import style0 from "./select-user.vue?vue&type=style&index=0&id=4522ed9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522ed9b",
  null
  
)

export default component.exports